export default {"gitHash":"a7768588fbb345f9ebb99a6bdab03a0bf68306e3","gitHashShort":"a776858","time":1680175156737,"platform":"linux","arch":"x64"};